export default __webpack_public_path__ + "static/splash-bfadc8f345162d503da8b0a228bcc840.jpg";